import React from "react";
import Forwards from "Components/repeater/Repeater";
import isEmail from "validator/lib/isEmail";
import Toggle from "Components/toggle/Toggle";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";
import t from "Utils/translation";

import cx from "classnames";

export default class AdvancedForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.firstInput.focus();
  }

  submit(e) {
    e.preventDefault();
    this.props.submitForm();
  }

  setKeepCopy(fieldValue) {
    if (fieldValue.forwards.length === 0) {
      this.props.setFormFieldValue({ ...fieldValue, keep_copy: false });
    } else {
      this.props.setFormFieldValue({ ...fieldValue });
    }
  }

  render() {
    const { setFormFieldValue, isFormLoading, formData, formErrors } = this.props;

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("emailAccounts.add.title.step4")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>emailAccounts.add.desc.step4</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="emailAccount_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.submit.bind(this)}>
            <div className="formsFP">
              <Forwards
                className="inputFull2"
                labelInput={t("input.label.forward.add")}
                label={t("listTable.header.title.forwards")}
                onChange={this.setKeepCopy.bind(this)}
                name="forwards"
                ref={el => (this.firstInput = el)}
                values={formData.forwards || []}
                validateNewValue={newVal => {
                  if (!isEmail(newVal)) {
                    alert(`${newVal} + ${t("errorMsg.notValid.emailAddress")}`);
                    return false;
                  }
                  return true;
                }}
                placeholder={t("input.placeholder.myOtherEmail")}
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.keepCopy")}
                name="keep_copy"
                disabled={formData.forwards && formData.forwards.length === 0}
                onChange={setFormFieldValue}
                checked={formData.keep_copy}
              />

              <Toggle
                className="inputFull2"
                label={t("input.label.spamInInbox")}
                name="spam_in_inbox"
                checked={formData.spam_in_inbox}
                onChange={setFormFieldValue}
              />
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="green" type="submit" loading={isFormLoading}>
                button.create
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
